interface ConnectionLostProps {
  open: boolean;
  retryNowEnabled: boolean;
  onRetryNow: () => void;
}

export function ConnectionLost({
  open,
  retryNowEnabled,
  onRetryNow,
}: ConnectionLostProps): JSX.Element | null {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-dash-bg/90 backdrop-blur-sm flex items-center justify-center">
      <div className="max-w-md w-full bg-dash-surface border border-error/40 rounded-lg p-6 space-y-3">
        <h2 className="text-base font-semibold text-dash-primary">
          Can't reach the dashboard server.
        </h2>
        <p className="text-sm text-dash-secondary">
          Retrying every 10 seconds. If this persists, check with engineering.
        </p>
        <button
          type="button"
          onClick={onRetryNow}
          disabled={!retryNowEnabled}
          className="text-xs font-mono text-accent hover:underline disabled:opacity-50"
        >
          Retry now
        </button>
      </div>
    </div>
  );
}
